/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterMenuAddPost } from '../fn/menu/api-master-menu-add-post';
import { ApiMasterMenuAddPost$Params } from '../fn/menu/api-master-menu-add-post';
import { apiMasterMenuDeleteGet } from '../fn/menu/api-master-menu-delete-get';
import { ApiMasterMenuDeleteGet$Params } from '../fn/menu/api-master-menu-delete-get';
import { apiMasterMenuEditPost } from '../fn/menu/api-master-menu-edit-post';
import { ApiMasterMenuEditPost$Params } from '../fn/menu/api-master-menu-edit-post';
import { apiMasterMenuGetActiveGet } from '../fn/menu/api-master-menu-get-active-get';
import { ApiMasterMenuGetActiveGet$Params } from '../fn/menu/api-master-menu-get-active-get';
import { apiMasterMenuGetActiveRouteGet } from '../fn/menu/api-master-menu-get-active-route-get';
import { ApiMasterMenuGetActiveRouteGet$Params } from '../fn/menu/api-master-menu-get-active-route-get';
import { apiMasterMenuGetAllGet } from '../fn/menu/api-master-menu-get-all-get';
import { ApiMasterMenuGetAllGet$Params } from '../fn/menu/api-master-menu-get-all-get';
import { apiMasterMenuGetByCriteriaPost } from '../fn/menu/api-master-menu-get-by-criteria-post';
import { ApiMasterMenuGetByCriteriaPost$Params } from '../fn/menu/api-master-menu-get-by-criteria-post';
import { apiMasterMenuGetMenuViewGet } from '../fn/menu/api-master-menu-get-menu-view-get';
import { ApiMasterMenuGetMenuViewGet$Params } from '../fn/menu/api-master-menu-get-menu-view-get';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';
import { Menu } from '../models/menu';
import { MenuApiRespModel } from '../models/menu-api-resp-model';
import { RouteModel } from '../models/route-model';
import { ViewMenu } from '../models/view-menu';

@Injectable({ providedIn: 'root' })
export class MenuService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterMenuAddPost()` */
  static readonly ApiMasterMenuAddPostPath = '/api/Master/Menu/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterMenuAddPost$Response(params?: ApiMasterMenuAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuApiRespModel>> {
    return apiMasterMenuAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterMenuAddPost(params?: ApiMasterMenuAddPost$Params, context?: HttpContext): Observable<MenuApiRespModel> {
    return this.apiMasterMenuAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuApiRespModel>): MenuApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterMenuEditPost()` */
  static readonly ApiMasterMenuEditPostPath = '/api/Master/Menu/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterMenuEditPost$Response(params?: ApiMasterMenuEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuApiRespModel>> {
    return apiMasterMenuEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterMenuEditPost(params?: ApiMasterMenuEditPost$Params, context?: HttpContext): Observable<MenuApiRespModel> {
    return this.apiMasterMenuEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<MenuApiRespModel>): MenuApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterMenuDeleteGet()` */
  static readonly ApiMasterMenuDeleteGetPath = '/api/Master/Menu/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuDeleteGet$Response(params?: ApiMasterMenuDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterMenuDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuDeleteGet(params?: ApiMasterMenuDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterMenuDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterMenuGetAllGet()` */
  static readonly ApiMasterMenuGetAllGetPath = '/api/Master/Menu/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetAllGet$Response(params?: ApiMasterMenuGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Menu>>> {
    return apiMasterMenuGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetAllGet(params?: ApiMasterMenuGetAllGet$Params, context?: HttpContext): Observable<Array<Menu>> {
    return this.apiMasterMenuGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Menu>>): Array<Menu> => r.body)
    );
  }

  /** Path part for operation `apiMasterMenuGetMenuViewGet()` */
  static readonly ApiMasterMenuGetMenuViewGetPath = '/api/Master/Menu/GetMenuView';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuGetMenuViewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetMenuViewGet$Response(params?: ApiMasterMenuGetMenuViewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ViewMenu>>> {
    return apiMasterMenuGetMenuViewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuGetMenuViewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetMenuViewGet(params?: ApiMasterMenuGetMenuViewGet$Params, context?: HttpContext): Observable<Array<ViewMenu>> {
    return this.apiMasterMenuGetMenuViewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ViewMenu>>): Array<ViewMenu> => r.body)
    );
  }

  /** Path part for operation `apiMasterMenuGetActiveRouteGet()` */
  static readonly ApiMasterMenuGetActiveRouteGetPath = '/api/Master/Menu/GetActiveRoute';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuGetActiveRouteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetActiveRouteGet$Response(params?: ApiMasterMenuGetActiveRouteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RouteModel>>> {
    return apiMasterMenuGetActiveRouteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuGetActiveRouteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetActiveRouteGet(params?: ApiMasterMenuGetActiveRouteGet$Params, context?: HttpContext): Observable<Array<RouteModel>> {
    return this.apiMasterMenuGetActiveRouteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RouteModel>>): Array<RouteModel> => r.body)
    );
  }

  /** Path part for operation `apiMasterMenuGetActiveGet()` */
  static readonly ApiMasterMenuGetActiveGetPath = '/api/Master/Menu/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetActiveGet$Response(params?: ApiMasterMenuGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Menu>>> {
    return apiMasterMenuGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterMenuGetActiveGet(params?: ApiMasterMenuGetActiveGet$Params, context?: HttpContext): Observable<Array<Menu>> {
    return this.apiMasterMenuGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Menu>>): Array<Menu> => r.body)
    );
  }

  /** Path part for operation `apiMasterMenuGetByCriteriaPost()` */
  static readonly ApiMasterMenuGetByCriteriaPostPath = '/api/Master/Menu/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterMenuGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterMenuGetByCriteriaPost$Response(params?: ApiMasterMenuGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Menu>>> {
    return apiMasterMenuGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterMenuGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterMenuGetByCriteriaPost(params?: ApiMasterMenuGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Menu>> {
    return this.apiMasterMenuGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Menu>>): Array<Menu> => r.body)
    );
  }

}
